import Sidebar from "./Sidebar";
import AdminSidebar from "./AdminSidebar";
import './admin_dashboard.css';
import React, { useState, useEffect } from "react";
import { fetchItems,createItem } from "../api/networking";
import AdminAutoTaskItem from "./admin_auto_task_item";
import AdminNeedApprovalTask from "./admin_need_appr_task_item";
import AdminModal from "./admin_modal";
import { useLocation } from "react-router-dom";
const mockTasks = [
    { id: 1, name: "Monthly Report - July" },
    { id: 2, name: "Quarterly Review Q2" },
    { id: 3, name: "Quarterly Review Q3" },
    { id: 4, name: "Quarterly Review Q4" },
    { id: 5, name: "Quarterly Review Q5" },
    { id: 6, name: "Quarterly Review Q6" },
    { id: 7, name: "Quarterly Review Q7" },
    { id: 8, name: "Quarterly Review Q8" },
    { id: 9, name: "Quarterly Review Q9" },
    { id: 10, name: "Quarterly Review Q10" },
    { id: 11, name: "Quarterly Review Q11" },
    { id: 12, name: "Quarterly Review Q12" },
  ];

const addTasks = [

  ];

const doneTasks = [

  ];

  


const AdminDashboard = ({initials}) => {
    const [selectedTask, setSelectedTask] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [pageSelected, setPageSelected] = useState([true,false,false,false])
    const [autoTasks, setAutoTasks] = useState([]);   
    const [needsApprovalTasks, setNeedsApprovalTasks] = useState([]);   
    const [inReviewTasks, setInReviewTasks] = useState([]); 
    



  
    const openModal = (task) => {

      setSelectedTask(task);
      setModalOpen(true);


    };


    const addTask = (task) => {
      
    };
  
    const closeModal = () => {
      setModalOpen(false);
      setSelectedTask(null);
    };

    const fetchAutomaticTasks = async () => {
      try {
        const data = await fetchItems('/get_supplement_task_list');
        console.log("Tasks:", data);
        setAutoTasks(data[1]);
      } catch (err) {
        console.error(err);
      }
    };


    const fetchNeedApprovalTasks = async () => {
      try {
        const data = await fetchItems('/get_financial_task_list');
        console.log("Needs Approval Tasks:", data);
        setNeedsApprovalTasks(data[1]);
      } catch (err) {
        console.error(err);
      }
    };

    const addNeedApprovalTasks = (index) => {
      const updatedList = [...inReviewTasks, needsApprovalTasks[index]];
      setInReviewTasks(updatedList);
    }

    useEffect(() => {
      if (pageSelected[0]) {
        setInReviewTasks([])
        fetchAutomaticTasks();
      }else if (pageSelected[1]) {
        setInReviewTasks([]);
        fetchNeedApprovalTasks();
      }
    }, [pageSelected]);

  
  return (
    <div className="dashboard">
    <AdminSidebar pageSelected={pageSelected} setPageSelected={setPageSelected}/>
    <div className="dashboard-content">
        {/* Top Static Header */}
        <div className="dashboard-header">
                <h1 className="dashboard-title">Welcome to the Admin Dashboard</h1>
                <div className="profile-circle drop-shadow" onClick={() => setShowModal(true)}>
                  {initials}
                </div>
          </div>
          <div>

          </div>

        {pageSelected[0]?<AdminAutoTaskItem litOfAutoTask={autoTasks}></AdminAutoTaskItem>:null}

        {pageSelected[1]?<AdminNeedApprovalTask needApprovalFunction={addNeedApprovalTasks} listOfTask={needsApprovalTasks}></AdminNeedApprovalTask>:null}

        {pageSelected[2]?<main className="dashboard-main">
            <h2>Review Tasks</h2>

            <ul className="task-list">
                {inReviewTasks.map((task,index) => (
                <li key={index} className="task-item" onClick={() => openModal(task)}>
                    {task.name}
                  <p>Task Name: {task.stock_symbol} - {task.financial_type}</p>
                  <p>Task Status: {task.isapproved?"Approved":"Need Approval"}</p>
                  <p>Task Type: {task.financial_file_type}</p>
                  <p>Date Of Data Pull: {task.date_completed}</p>
                  <p>Year Of Financial Data:{task.date_of_financial_data} </p>
                </li>
                ))}
            </ul>
        </main>:null}

        {pageSelected[3]?<main className="dashboard-main">
            <h2>Done Tasks</h2>

            <ul className="task-list">
                {doneTasks.map((task) => (
                <li key={task.id} className="task-item" onClick={() => openModal(task)}>
                    {task.name}
                    <input type="checkbox"></input>
                </li>
                ))}
            </ul>
        </main>:null}


      </div>
         {/* Modal */}
         {<AdminModal 
          modalOpen={modalOpen} 
          selectedTask={selectedTask} 
          closeModal={closeModal} 
          />
}
  </div>
  );
};

export default AdminDashboard;